import { sync } from 'vuex-pathify';
export default {
  computed: {
    floatingFilterOpened: sync('table/floatingFilterOpened'),
    toggleFilterHeadersButton() {
      return {
        name: 'toggleFilterHeaders',
        icon: 'mdi-filter-variant',
        tooltip: this.isModifySnappingActive
          ? this.$i18n.t('button.toManageFilters', { reason: this.$i18n.t('button.turnOffEditing') })
          : this.$i18n.t('button.columnFilter'),
        fontSize: '19px',
        hasState: true,
        isActive: Boolean(this.isHeadersFilterActive),
        disabled: this.isModifySnappingActive,
      };
    },
    toggleFilterBuilderButton() {
      return {
        name: 'toggleFilterBuilder',
        icon: this.isBuilderFilterActive ? '$filteractive' : '$filter',
        tooltip: this.isModifySnappingActive
          ? this.$i18n.t('button.toManageFilters', { reason: this.$i18n.t('button.turnOffEditing') })
          : this.$i18n.t('button.advancedFilter'),
        hasState: true,
        isActive: Boolean(this.isBuilderFilterActive),
        disabled: this.isModifySnappingActive,
      };
    },
    toggleFilterClearButton() {
      return {
        name: 'toggleFilterClear',
        icon: '$unfilter',
        tooltip: this.isModifySnappingActive
          ? this.$i18n.t('button.toManageFilters', { reason: this.$i18n.t('button.turnOffEditing') })
          : this.isFilterActive
          ? this.$i18n.t('button.clearAllFilters')
          : this.$i18n.t('button.noFilterToRemove'),
        disabled: !this.isFilterActive || this.isModifySnappingActive,
      };
    },
    toggleFilterSelectedButton() {
      return {
        name: 'toggleFilterSelected',
        icon: 'mdi-table-arrow-up',
        tooltip: !this.isAnyFeatureSelected
          ? this.$i18n.t('button.noObjectsSelected', { suffix: '' })
          : this.isFilterSelectedActive
          ? this.$i18n.t('button.backToList')
          : this.$i18n.t('button.toggleFilterSelected'),
        disabled: !this.isAnyFeatureSelected,
        isActive: this.isFilterSelectedActive,
        fontSize: '19px',
      };
    },
  },
};
